export default __webpack_public_path__ + "fonts/login_2.4c759843cc379d9c40e7ea51fc6eac01.png";